module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/feature01-90a0d63b5d0c4b6159ad9c6667417525.svg";